export default __webpack_public_path__ + "static/media/document.8bb4ae27.png";